import { cn } from "@omni/utils/styles";
import React from "react";

import { FormText } from "@/components/Form/Base/formText.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { useFormInfoContext } from "@/utils/forms/formInfo.provider";

type Props = {
    fieldId: string;
    className?: string;
};

const MicroCopy = ({ fieldId, className }: Props) => {
    const microCopyContext = useFormInfoContext();
    const { t } = useGranite();

    if (microCopyContext?.formId && fieldId) {
        const translationKey = `form.microcopy.${microCopyContext.formId}.${fieldId}`;
        const translation = t(translationKey);

        if (translation) {
            return (
                <FormText
                    inline={true}
                    color="default"
                    className={cn("tw:-mt-2 tw:mb-2 tw:block", className)}
                >
                    {translation}
                </FormText>
            );
        }
    }

    return <React.Fragment />;
};

export { MicroCopy };
